import { render } from "./popper.vue?vue&type=template&id=798596a4"
import script from "./popper.vue?vue&type=script&lang=js"
export * from "./popper.vue?vue&type=script&lang=js"

import "./popper.vue?vue&type=style&index=0&id=798596a4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/popper/popper.vue'],['render',render],['__file',"popper.vue"]])

export default __exports__